"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var event_1 = require("../../util/event");
exports.EVENT_MAP = event_1.EVENT_MAP;
exports.onEvent = event_1.onEvent;
var SHAPE_EVENT_MAP = {
    onPieClick: 'interval:click',
    onPieDblclick: 'interval:dblclick',
    onPieMousemove: 'interval:mousemove',
    onPieMouseenter: 'interval:mouseenter',
    onPieMouseleave: 'interval:mouseleave',
    onPieMousedown: 'interval:mousedown',
    onPieMouseup: 'interval:mouseup',
    onPieContextmenu: 'interval:contextmenu',
};
_.assign(event_1.EVENT_MAP, SHAPE_EVENT_MAP);
//# sourceMappingURL=event.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/pie/event.js
// module id = 948
// module chunks = 37